import { UtilityService } from '../utility.service';
import { ConsentsStatusService } from './consents-status.service';
import { DataService } from '../utilities/data.service';
import { Consent } from '../../dataTypes/type-consent';
import DataExchangeService from '../data-exchange.service';

/**
 * Class responsible for sending data to the CDCS-IFrame
 */
export class CDCSyncService {
    private utilityService: UtilityService;

    constructor(utilityService: UtilityService) {
        this.utilityService = utilityService;
    }

    /**
     * Updates the controllerId globally and for all consents
     * @param id The new controllerId that is set
     */
    static updateControllerId(id: string) {
        if (DataService.controllerId !== id) {
            DataService.storeGlobally('controllerId', id);
            DataService.consents.forEach(element => {
                element.controllerId = id;
            });
        }
    }

    /**
     * Syns the local consent data with the Iframe
     */
    syncConsentDataWithCdcsIframeWhenConsentsAreNotReset() {

        const allConsents = DataService.consents;
        // find alternate
        const consentsThatAreNew = [];

        allConsents.forEach((consent) => {
            const index = this.utilityService.crossDomainConsentSharingService.crossDomainConsentArray
                .map(function(e) {
                    return e.templateId;
                })
                .indexOf(consent.templateId);

            // the consent exists in the iframe.
            // If consent does not exist in the iframe it will be handled by the reset case.
            if (index !== -1) {
                const object = this.utilityService.crossDomainConsentSharingService.crossDomainConsentArray[index];
                CDCSyncService.updateControllerId(object.controllerId);
                consent.processorId = object.processorId;
                consent.consentId = object.consentId;
                consent.history = object.history ? object.history : consent.history;
                const isStatusChanged = consent.consentStatus !== object.consentStatus;
                ConsentsStatusService.setUnsavedConsentStatus(consent, object.consentStatus);
                consent.consentStatus = object.consentStatus;
                if (isStatusChanged) {
                    const dataExchangeService = new DataExchangeService()
                    dataExchangeService.dataExchangeArray = this.utilityService.settingsService.settings.dataExchangeOnPage;
                    dataExchangeService.dispatchEventForConsent(consent, DataService.consentTemplates);
                }
            } else {
                // in case the consent does not exist in the iframe.
                consentsThatAreNew.push(consent);
            }
        });
        DataService.storeGlobally('consents', allConsents);
        if (consentsThatAreNew.length) {
            this.utilityService.crossDomainConsentSharingService.updateIframeStorageToLatest(consentsThatAreNew);
        }
    }
}
